import type { WidgetGridLayout } from '@trinity/chat';

export function getBlockById(instance: WidgetGridLayout, blockId: string) {
  return instance.blocks.find((block) => block.id === blockId) || null;
}

export function getSectionById(instance: WidgetGridLayout, blockId: string, sectionId: string) {
  const block = getBlockById(instance, blockId);
  if (!block) return null;
  return block.sections.find((section) => section.id === sectionId) || null;
}